import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from '../_constants/constants';
import { UserService } from '../_services/user.service';
import { User } from '../_models/user';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css'],
    standalone: false
})
export class TopbarComponent implements OnInit, OnDestroy {

    appCurrentLang: string;
    user: User | null = null;
    availableLangs: string[] = [AppConstants.FRENCH, AppConstants.ENGLISH];
    currentLanguage: string | null = null;
    private userSubscription: Subscription;
    private langChangeSubscription: Subscription;

    constructor(
        private translationService: TranslateService,
        public userService: UserService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
    }

    changeLanguage(newLanguage: string) {
        // use the new languages
        if (this.availableLangs.includes(newLanguage)) {
            this.translationService.use(newLanguage)
                .subscribe(response => {
                    localStorage.setItem(AppConstants.CURRENT_LANG_STORE_KEY, newLanguage);
                    this.appCurrentLang = newLanguage;
                    window.location.reload();
                });
        } else { throw new Error('Unknown Language'); }
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY)??this.currentLanguage;
            localStorage.setItem(AppConstants.CURRENT_LANG_STORE_KEY, this.currentLanguage);
        }

        this.appCurrentLang = this.translationService.currentLang || AppConstants.FRENCH;
        this.langChangeSubscription = this.translationService.onLangChange.subscribe(event => {
            this.appCurrentLang = event.lang;
        });

        // Subscribe to user changes for reactive updates
        this.userSubscription = this.userService.currentUser$.subscribe(user => {
            this.user = user;
        });
    }

    ngOnDestroy(): void {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }

    /**
     * Check if the current user can access the sell functionality.
     * Only verified sellers can sell products.
     * Buyers, carriers, and regular users should never see the sell button.
     */
    get canSell(): boolean {
        if (!this.user) {
            return false;
        }

        const role = this.user.role?.toLowerCase();

        // Only sellers can sell - explicitly exclude buyer, carrier, user, and other roles
        if (role !== 'seller') {
            return false;
        }

        // Must have seller data with VERIFIED status
        return this.user.seller?.status === 'VERIFIED';
    }

}
